export default {
  specsvalue: 'Valeur',
  specsvalues: 'Valeurs',
  verbose_specsvalue: 'une valeur',
  increment: 'Incrément',
  short_title: 'Titre court',
  use_exceptions: 'Utiliser les exceptions',
};
